export const SubscriptionCategoryPermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'product.subscriptionCategory.list-view',
    UPDATE: 'product.subscriptionCategory.list-update',
    DELETE: 'product.subscriptionCategory.list-delete',
  },
});
